var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1068_19892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10779 3.7633C6.84575 2.43998 7.21444 1.77832 7.76602 1.77832C8.3176 1.77832 8.68629 2.43998 9.42425 3.7633L9.61529 4.10578C9.82497 4.48204 9.92981 4.67017 10.0929 4.79424C10.256 4.9183 10.4598 4.96431 10.8676 5.05634L11.238 5.14021C12.6708 5.46463 13.3866 5.62655 13.5573 6.17464C13.7274 6.72214 13.2393 7.29352 12.2625 8.4357L12.0097 8.731C11.7325 9.05542 11.5933 9.21793 11.531 9.41829C11.4686 9.61923 11.4896 9.8359 11.5315 10.2687L11.57 10.663C11.7173 12.1872 11.7913 12.9491 11.3452 13.2875C10.899 13.6259 10.228 13.3172 8.88723 12.6998L8.53951 12.5402C8.15859 12.3643 7.96813 12.2769 7.76602 12.2769C7.56391 12.2769 7.37345 12.3643 6.99253 12.5402L6.64539 12.6998C5.30401 13.3172 4.63303 13.6259 4.18746 13.2881C3.74072 12.9491 3.8147 12.1872 3.96205 10.663L4.0005 10.2692C4.04243 9.8359 4.0634 9.61923 4.0005 9.41887C3.93876 9.21793 3.79955 9.05542 3.52231 8.73158L3.26952 8.4357C2.29276 7.2941 1.80467 6.72272 1.97474 6.17464C2.14482 5.62655 2.86181 5.46405 4.29463 5.14021L4.66507 5.05634C5.0722 4.96431 5.27547 4.9183 5.43914 4.79424C5.60281 4.67017 5.70707 4.48204 5.91675 4.10578L6.10779 3.7633Z",
    stroke: "#CECECE",
    strokeWidth: 0.873672
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1068_19892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9787,
    height: 13.9787,
    fill: "white",
    transform: "translate(0.777344 0.613281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar0);
export default __webpack_public_path__ + "static/media/rating-star-0.854d979ddbd6c5e709ae65e8b6606241.svg";
export { ForwardRef as ReactComponent };